import axios from '@/util/requestUtil'
class Transfer {
  getTransferRecords (params) {
    return axios.get('/fund/transfer/application/records', params)
  }
  commitTransfer (params) {
    return axios.post('/fund/transfer/application', params)
  }
  // 撤销-内部转账单
  cancelTransfer (params) {
    return axios.post('/fund/transfer/cancel', params)
  }
}
export default new Transfer()
